
import React from "react";
import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

export default function MakingThings() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section ref={ref} className="bg-white py-32 lg:py-40 px-8">
      <div className="max-w-5xl mx-auto text-center">
        {/* Header */}
        <div
          className={`mb-12 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="text-sm uppercase tracking-widest text-gray-500 mb-5">
            Making Thingsとは
          </h2>
          <div className="w-20 h-px bg-gray-300 mx-auto"></div>
        </div>

        {/* Content */}
        <div className="space-y-16">
          {/* Japanese description */}
          <p
            className={`text-2xl lg:text-3xl leading-loose text-gray-900 font-light transition-all duration-700 delay-200 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            BITMOVESにとっての「つくる」は、デザインや制作だけを意味しません。<br />
            空間の条件、運用、文化、基準の違いを読み解き、<br />
            その場で機能する形へと翻訳し、成立させること。<br />
            それが私たちのクリエイティブです。
          </p>

          {/* English description */}
          <p
            className={`text-lg lg:text-xl leading-relaxed text-gray-600 italic max-w-4xl mx-auto transition-all duration-700 delay-[400ms] ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            For BITMOVES, &quot;Making Things&quot; is more than design and
            production.<br />
            It means translating constraints, standards, and realities<br />
            into solutions that truly belong to each space.
          </p>
        </div>
      </div>
    </section>
  );
}
